import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from './helper';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent implements OnInit, AfterViewInit {

    constructor() { }

    ngOnInit() {
    }
    ngAfterViewInit() {
        Helpers.bodyClass('m--skin- m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/common/error/error.component.ts